import {
  ROOT_PATH,
  LEAGUE_PATH,
  LER_NEWSSTAND_ROOT_PATH,
  ACTIVITIES_PATH,
  MY_READINGS_MODULAR_FAVORITES_PATH,
  SEARCH_PATH,
  FOREST_PATH,
  ADMIN_REPORTS_PATH,
  ADMIN_BNCC_DIDACTIC_SEQUENCE_PATH,
  ADMIN_ENTITY_USERS_PATH,
  ADMIN_ENTITY_USERS_V2_PATH,
  ADMIN_ROOT_PATH,
  ADMIN_BOOKS_MANAGEMENT_PATH,
  MY_READINGS_MODULAR_PATH,
  MY_READINGS_MODULAR_INDICATED_PATH,
  ADMIN_ACCESS_REPORT_PATH,
  ADMIN_READING_GOALS_REPORT_PATH,
  ADMIN_ENTITY_USERS_ONLINE_STATUS_PATH,
  ADMIN_SUMMARY_REPORT_V2_PATH,
  ADMIN_TIME_USAGE_REPORTS_PATH,
  ADMIN_ACTIVITIES_CREATE_ACTIVITY_PATH,
  ADMIN_ACTIVITIES_CREATE_ACTIVITY_SIMPLE_PATH,
  ADMIN_PUBLIC_ACTIVITIES_PATH_V2,
  ADMIN_ACTIVITIES_HOME_PATH,
  ADMIN_ACTIVITIES_MY_ACTIVITIES_PATH,
  ADMIN_ACTIVITIES_APPLIED_ACTIVITIES_PATH,
  ADMIN_ACTIVITIES_CORRECT_ACTIVITY_PATH,
  ADMIN_ACTIVITIES_EDIT_ACTIVITY_PATH,
  ADMIN_JOB_POSITIONS_AND_PERMISSIONS,
  ADMIN_SUMMARY_REPORT_V3_PATH,
  ADMIN_RUNNING_RECORDS_REPORT_PATH
} from 'routes/paths'
import type { LocationType } from './types'
import type { UserState } from 'utils/hooks/use-userInfo'

const ACTIVITY_PATHS = [
  ADMIN_ACTIVITIES_CREATE_ACTIVITY_PATH,
  ADMIN_ACTIVITIES_CREATE_ACTIVITY_SIMPLE_PATH(),
  ADMIN_ACTIVITIES_HOME_PATH,
  ADMIN_ACTIVITIES_MY_ACTIVITIES_PATH,
  ADMIN_ACTIVITIES_APPLIED_ACTIVITIES_PATH,
  ADMIN_PUBLIC_ACTIVITIES_PATH_V2,
  ADMIN_ACTIVITIES_CORRECT_ACTIVITY_PATH(),
  ADMIN_ACTIVITIES_EDIT_ACTIVITY_PATH()
]

function getAdminRedirectPath(user: UserState, currentPath: string): string {
  if (!user.canManageActivity && ACTIVITY_PATHS.includes(currentPath)) {
    return ADMIN_SUMMARY_REPORT_V3_PATH
  }

  return user.canAccessAdminPanel ? ADMIN_SUMMARY_REPORT_V3_PATH : ROOT_PATH
}

function getRedirectLocation(user: UserState, currentPath): LocationType {
  /**
   * Reader features
   */
  if (
    (!user.canAccessPressreaderContent &&
      currentPath === LER_NEWSSTAND_ROOT_PATH) ||
    (!user.canAccessIndications &&
      currentPath === MY_READINGS_MODULAR_INDICATED_PATH) ||
    (!user.canAccessMyReadings && currentPath === MY_READINGS_MODULAR_PATH) ||
    (!user.canAccessFavorites &&
      currentPath === MY_READINGS_MODULAR_FAVORITES_PATH) ||
    (!user.canAccessActivities && currentPath === ACTIVITIES_PATH) ||
    (!user.canAccessSearch && currentPath === SEARCH_PATH()) ||
    (!user.canAccessForest && currentPath.includes(FOREST_PATH)) ||
    (!user.canAccessLeagueContent && currentPath === LEAGUE_PATH) ||
    (!user.canAccessAdminPanel && currentPath.includes(ADMIN_ROOT_PATH)) ||
    (user.isContextNonEducational &&
      currentPath === MY_READINGS_MODULAR_INDICATED_PATH) ||
    (user.featureToggles?.paranaNotice &&
      currentPath.includes('/fazer-atividade/'))
  ) {
    return {
      pathname: ROOT_PATH
    }
  }

  /**
   * Admin features
   */
  if (
    (!user.featureToggles?.newPermissionsManagement &&
      currentPath.includes(ADMIN_JOB_POSITIONS_AND_PERMISSIONS)) ||
    (!user.canAccessUsageReports && currentPath.includes(ADMIN_REPORTS_PATH)) ||
    (!user.canAccessCustomCollections &&
      currentPath.includes(ADMIN_BOOKS_MANAGEMENT_PATH)) ||
    (!user.canAccessDidacticSequences &&
      currentPath.includes(ADMIN_BNCC_DIDACTIC_SEQUENCE_PATH)) ||
    (!user.canAccessEntityUsersManagement &&
      (currentPath === ADMIN_ENTITY_USERS_PATH ||
        currentPath === ADMIN_ENTITY_USERS_V2_PATH)) ||
    (!user.canManageActivity && ACTIVITY_PATHS.includes(currentPath)) ||
    (!user.featureToggles?.reportReadingGoalsEnabled &&
      currentPath.includes(ADMIN_READING_GOALS_REPORT_PATH)) ||
    (!user.featureToggles?.paranaNotice &&
      currentPath.includes(ADMIN_ACCESS_REPORT_PATH)) ||
    (!user.featureToggles?.entityUsersOnlineStatus &&
      currentPath.includes(ADMIN_ENTITY_USERS_ONLINE_STATUS_PATH)) ||
    (!user.featureToggles?.usageTime &&
      currentPath.includes(ADMIN_TIME_USAGE_REPORTS_PATH)) ||
    (!user.featureToggles?.storyTree &&
      !user.featureToggles?.runningRecords &&
      currentPath.includes(ADMIN_RUNNING_RECORDS_REPORT_PATH))
  ) {
    return {
      pathname: getAdminRedirectPath(user, currentPath)
    }
  }

  if (user.featureToggles?.paranaNotice && currentPath === ADMIN_ROOT_PATH) {
    return {
      pathname: ADMIN_SUMMARY_REPORT_V2_PATH
    }
  }

  return {
    pathname: ''
  }
}

export default {
  getRedirectLocation
}
